import axios from 'axios';
import querystring from 'querystring';
export var sendRequest = function sendRequest(url, method, data, token) {
  var baseURL = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'https://cs2n.org';
  return axios({
    method: method,
    baseURL: baseURL,
    url: url,
    data: querystring.stringify(data),
    headers: {
      authorization: "Bearer ".concat(token),
      'content-type': 'multipart/form-data'
    }
  });
};